// 予約自動取り消し期限を超えているとtrueを返す
export const isOverAutoCanceledAt = (auto_canceled_at) => {
  if (auto_canceled_at == null) {
    return false;
  } else {
    const now = new Date();
    const autoCanceledAt = new Date(auto_canceled_at);
    return now >= autoCanceledAt;
  }
};
